<template>
  <div class="details">
    <table>
      <!-- Quantity x Plan -->
      <tr>
        <td>{{ quantity }} <span v-html="MIXIN_MULTIPLICATION_SIGN"></span> {{ name }}</td>
        <td class="text-right">
          <span class="peso" v-html="MIXIN_PESO_SIGN"></span>{{ (amount * quantity) | numFormat('0,0.00') }}
        </td>
      </tr>
      <!-- Discount -->
      <tr v-if="discount">
        <td>
          <span class="peso" v-html="MIXIN_PESO_SIGN"></span>{{ discount | numFormat('0,0.00') }} Discount</td>
        <td class="text-right">
          <span class="peso" v-html="MIXIN_PESO_SIGN"></span>{{ discount | numFormat('0,0.00') }}
        </td>
      </tr>
      <!-- Discounted Total -->
      <tr v-if="discount">
        <td>Discounted Total</td>
        <td class="text-right">
          <span class="peso" v-html="MIXIN_PESO_SIGN"></span>{{ total | numFormat('0,0.00') }}
        </td>
      </tr>
      <!-- Member -->
      <tr v-if="member!==null">
        <td class="pr-5">
          <div class="d-inline">
            <span>{{ memberQuantity }} <span v-html="MIXIN_MULTIPLICATION_SIGN"></span> Household member residing in the same household 18 years old and above</span>
            <!-- Increase Quantity -->
            <!-- <div
              class="text-hover mx-2 align-center d-inline quantity"
              @mouseenter="hover = true"
              @mouseleave="hover = false"
              @click="decrease"
            >
              <v-icon small :color="hover ? 'accent' : 'grey'">mdi-minus</v-icon>
            </div> -->
            <!-- Decrease Quantity -->
            <!-- <div
              class="text-hover align-center d-inline quantity"
              @mouseenter="hover = true"
              @mouseleave="hover = false"
              @click="increase"
            >
              <v-icon small :color="hover ? 'accent' : 'grey'">mdi-plus</v-icon>
            </div> -->
          </div>
        </td>
        <td class="text-right">
          <span class="peso" v-html="MIXIN_PESO_SIGN"></span>{{ memberTotal | numFormat('0,0.00') }}
        </td>
      </tr>
      <!-- Subtotal -->
      <tr v-if="member!==null">
        <td>Subtotal</td>
        <td class="text-right">
          <span class="peso" v-html="MIXIN_PESO_SIGN"></span>{{ subtotal | numFormat('0,0.00') }}
        </td>
      </tr>
      <!-- VAT -->
      <tr>
        <td>12% value added tax (VAT)</td>
        <td class="text-right">
          <span class="peso" v-html="MIXIN_PESO_SIGN"></span>{{ vatAmount | numFormat('0,0.00') }}
        </td>
      </tr>
      <!-- Total Cost -->
      <tr class="font-weight-bold">
        <td>Total Cost</td>
        <td class="text-right">
          <span class="peso" v-html="MIXIN_PESO_SIGN"></span>{{ totalCost | numFormat('0,0.00') }}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
  export default {
    name: "CartSummaryDetails",

    props: {
      quantity: { type: Number, default: 0 },
      name: { type: String, default: '' },
      amount: { type: Number, default: 0 },
      description: { type: String, default: '' },
      discount: { type: Number, default: 0 },
      total: { type: Number, default: 0 },
      member: { default: null }
    },

    data: () => ({
      hover: false
    }),

    mounted() {
      console.log(this.member)
    },

    computed: {
      memberQuantity() {
        if (this.$route.name == 'ShopCheckout')
					return this.$store.getters['cart/memberQuantity']
				else if (this.$route.name == 'ShopMerchantCheckout')
					return this.$store.getters['merchantCart/memberQuantity']
				else
					return this.$store.getters['promoCart/memberQuantity']
      },
      subtotal() {
        return this.total+this.memberTotal;
      },
      memberTotal() {
        let quantity = this.memberQuantity
        var amount = 0
        if (this.$route.name == 'ShopCheckout')
					amount = this.$store.getters['cart/member']
				else if (this.$route.name == 'ShopMerchantCheckout')
					amount = this.$store.getters['merchantCart/member']
				else
          amount = this.$store.getters['promoCart/member']
          
        return quantity*amount;
      },
      vatAmount() {
        return this.subtotal*0.12
      },
      totalCost() {
        return this.subtotal+this.vatAmount
      }
    },

    methods: {
      increase() {
        if (this.$route.name == 'ShopCheckout')
					this.$store.commit('cart/increaseMemberQuantity')
				else if (this.$route.name == 'ShopMerchantCheckout')
					this.$store.commit('merchantCart/increaseMemberQuantity')
				else
          this.$store.commit('promoCart/increaseMemberQuantity')
      },
      decrease() {
        if (this.$route.name == 'ShopCheckout')
					this.$store.commit('cart/decreaseMemberQuantity')
				else if (this.$route.name == 'ShopMerchantCheckout')
					this.$store.commit('merchantCart/decreaseMemberQuantity')
				else
          this.$store.commit('promoCart/decreaseMemberQuantity')
      },
      // setQuantity() {
      //   this.$stora.commit('cart/setMemberQuantity')
      // }
    }
  }
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.details {
  color: black !important;
  font-weight: normal;
}

.peso {
	font-family: Arial;
}

table {
  width: 100%;
}

.quantity {
  border: 1px solid grey;
  padding-left: 2px;
  padding-right: 2px;
}

.quantity:hover {
  border-color: $accent-blue;
}
</style>